import React from 'react';
import PropTypes from 'prop-types';
import { Box, Paper } from '@mui/material';

import { useTheme } from 'contexts/ThemeContext';

import { Text } from 'components/DataDisplay';
import { Button } from 'components/Inputs';

export const DomainPageActionBar = props => {
  const {
    title,
    onCancel,
    onCreate,
    onSave,
    saveLabel,
    createLabel,
    showCreate,
    saveDisabled
  } = props;
  const { themeColors } = useTheme();

  return (
    <Box
      sx={{
        width: '100%',
        maxWidth: '100%',
        position: 'sticky',
        top: {
          xs: '245px',
          md: '100px'
        },
        zIndex: 20,
        marginBottom: '0.75rem'
      }}
    >
      <Paper
        elevation={2}
        sx={{
          width: '100%',
          maxWidth: '100%',
          boxSizing: 'border-box',
          borderRadius: '0 0 8px 8px',
          padding: '0.625rem 0.875rem'
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: '12px',
            flexWrap: 'wrap',
            minWidth: 0
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              flex: '1 1 18rem',
              minWidth: 0,
              flexWrap: 'wrap'
            }}
          >
            <Text
              bold
              variant="h6"
              color={themeColors.themeV2.black}
              style={{
                minWidth: 0,
                fontSize: '0.95rem',
                lineHeight: 1.3,
                overflowWrap: 'anywhere'
              }}
            >
              {title}
            </Text>
            {showCreate && (
              <Button
                variant="contained"
                color={themeColors.themeV2.black}
                size="medium"
                onClick={onCreate}
              >
                {createLabel}
              </Button>
            )}
          </Box>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end',
              gap: '8px',
              flexWrap: 'wrap',
              minWidth: 0
            }}
          >
            <Button
              variant="outlined"
              color={themeColors.backoffice.global}
              size="medium"
              onClick={onCancel}
            >
              Annuler
            </Button>
            <Button
              variant="contained"
              color={themeColors.backoffice.global}
              size="medium"
              disabled={saveDisabled}
              onClick={onSave}
            >
              {saveLabel}
            </Button>
          </Box>
        </Box>
      </Paper>
    </Box>
  );
};

DomainPageActionBar.defaultProps = {
  createLabel: 'Créer un nouveau domaine',
  saveLabel: 'Mettre à jour le domaine',
  showCreate: true,
  saveDisabled: false
};

DomainPageActionBar.propTypes = {
  title: PropTypes.string.isRequired,
  onCancel: PropTypes.func.isRequired,
  onCreate: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  createLabel: PropTypes.string,
  saveLabel: PropTypes.string,
  showCreate: PropTypes.bool,
  saveDisabled: PropTypes.bool
};

export default DomainPageActionBar;
